"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { popoverVariants } from "./Popover.variants.js";
import { usePopoverMode } from "./PopoverContext.js";
const { backdrop: backdrop } = popoverVariants();
const PopoverBackdrop_PopoverBackdrop = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    const mode = usePopoverMode();
    const classes = cn(backdrop(), className, slots?.backdrop);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Backdrop, {
        ref: ref,
        className: classes,
        ...props
    });
    return /*#__PURE__*/ jsx(Popover.Backdrop, {
        ref: ref,
        className: classes,
        ...props
    });
});
export { PopoverBackdrop_PopoverBackdrop as PopoverBackdrop };
